import React from "react";

interface MobileFooterProps {
  children: React.ReactNode;
}

export default function MobileFooter({ children }: MobileFooterProps) {
  return <div className="modal_footer-mobile">{children}</div>;
}
